import { useEffect } from 'react';

import { useDialog } from '@explorer/hooks/useDialog/useDialog';
import { ControlClientInfoResponse } from '@explorer/open-api-client';

import { WizerCreateAccountModal } from './WizerCreateAccountModal';

interface WizerCreateAccountProps {
  activeClient: ControlClientInfoResponse;
  triggerSave: () => void; // Invokes the parent form's save
  triggerUncheck: () => void; // Unchecks the SAT module
}

/*
  This component is used to create a new Wizer account for a client.
  It is automatically displayed when the SAT module is enabled (checked).
  On account creation, it triggers the parent form's save.
  On cancellation (close or x), it unchecks the SAT module.
*/
export const WizerCreateAccount = ({
  activeClient,
  triggerSave,
  triggerUncheck,
}: WizerCreateAccountProps) => {
  const users = (activeClient?.associated_users ?? []).filter(
    (user) => user.is_active,
  );

  const { open, openDialog, closeDialog } = useDialog();

  const handleClose = (cancelled: boolean) => {
    if (cancelled) {
      triggerUncheck();
    } else {
      triggerSave();
    }
    closeDialog();
  };

  useEffect(() => {
    if (users.length > 0) {
      openDialog();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!users || users.length === 0 || !open) {
    return null;
  }

  // Only display if there are active users
  return (
    <WizerCreateAccountModal
      activeClient={activeClient}
      open={open}
      handleClose={handleClose}
    />
  );
};
